import { useMemo } from 'react'
import {
  getDatePositionOnTimeline,
  sortGanttFooterMilestones
} from '../Gantt.utils'
import type { GanttChartProps } from '../GanttChart.types'
import { MONTH_COLUMN_GAP } from '../GanttChart.styles'

type MilestoneWithPosition = {
  label: string
  date: string
  description?: string
  left: number
  renderKey: string
}

type UseGanttFooterMilestonesArgs = {
  footer: GanttChartProps['props']['footer']
  year: number
  timelineWidth: number
}

const useGanttFooterMilestones = ({
  footer,
  year,
  timelineWidth
}: UseGanttFooterMilestonesArgs) => {
  const footerMilestones = useMemo(() => {
    return sortGanttFooterMilestones(footer?.milestones)
      .map((milestone, index) => {
        const left = getDatePositionOnTimeline({
          isoDate: milestone.date,
          year,
          timelineWidth,
          monthColumnGap: MONTH_COLUMN_GAP
        })
        if (left === null) return null

        return {
          ...milestone,
          left,
          renderKey: `${milestone.label}-${milestone.date}-${index}`
        }
      })
      .filter(
        (milestone): milestone is MilestoneWithPosition => milestone !== null
      )
  }, [footer?.milestones, year, timelineWidth])

  return { footerMilestones }
}

export default useGanttFooterMilestones
